import { apiFetch } from "./api-client";

export type SetupGoal = {
  id: string;
  variable: string;
  goal: string;
  required?: false;
};

export type ApprovalReview = {
  title: string;
  summary: string;
  confirmationLabel: string;
  reviewFingerprint: string;
};

export type SetupStatus =
  | "not_started"
  | "active"
  | "awaiting_approval"
  | "completed";

export type PublicSetupProgress = {
  setup: {
    id: string;
    goals: SetupGoal[];
  };
  status: SetupStatus;
  savedVariables: string[];
  missingGoals: SetupGoal[];
  approvalReview: ApprovalReview | null;
};

export type AgenticOnboardingProgress = {
  activeSetup: PublicSetupProgress | null;
  setups: PublicSetupProgress[];
  complete: boolean;
  hasCompany: boolean;
};

export type AgenticOnboardingAgentState = {
  progress: AgenticOnboardingProgress | null;
  lastTurnIssue: {
    traceId: string;
    reason: string;
    kind: "empty_response" | "tool_failure";
  } | null;
};

export async function fetchOnboardingProgress(): Promise<AgenticOnboardingProgress> {
  const response = await apiFetch("/api/v1/onboarding/progress");
  if (!response.ok) {
    throw new Error(`Unable to load onboarding progress (${response.status})`);
  }

  const body = (await response.json()) as {
    data: { progress: AgenticOnboardingProgress };
  };
  return body.data.progress;
}
